import { render, staticRenderFns } from "./ClaimUnPatrolList.vue?vue&type=template&id=2fa89fe0&"
import script from "./ClaimUnPatrolList.vue?vue&type=script&lang=js&"
export * from "./ClaimUnPatrolList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports